var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'section-statistics__tab', 'section-statistics__row',
    {'section-statistics__row--long-table-mode': _vm.longTablePart}
  ]},[_c('BarPart'),_c('TablePart'),(!_vm.longTablePart)?[(_vm.commType === 'email')?_c('DomainsCard'):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }